(function (d, s, id) {
    var js,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0';
    fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

(function ($) {
    RVwys.plugin['Facebook'] = true;
    $(document).bind('editorReady', function () {
        $('.add-change-value').change(function () {
            jQuery.sitebuilder.socialNetwork.addViewlikeboxOption(
                jQuery(this),
                ''
            );
        });
        $('.edit-change-value').change(function () {
            jQuery.sitebuilder.socialNetwork.editlikeboxOption(jQuery(this));
        });
        $('.like-button-preview').change(function () {
            jQuery.sitebuilder.socialNetwork.addViewlikeButtonOption(
                jQuery(this),
                ''
            );
        });
        $('.edit-like-button-preview').change(function () {
            jQuery.sitebuilder.socialNetwork.editlikebuttonOption(jQuery(this));
        });
        $('.comment-preview').change(function () {
            jQuery.sitebuilder.socialNetwork.addViewCommentOption(
                jQuery(this),
                ''
            );
        });
        $('.edit-comment-preview').change(function () {
            jQuery.sitebuilder.socialNetwork.editViewCommentOption(
                jQuery(this)
            );
        });
        $('#fbLike,#ahref_fbLike').click(function () {
            jQuery.sitebuilder.socialNetwork.addViewlikebutton();
        });
        $('#fbFunpage,#ahref_fbFunpage').click(function () {
            var cloneRange = RVwys.getRange();
            jQuery.sitebuilder.socialNetwork.addViewlikebox();
        });
        $('#fbComment,#ahref_fbComment').click(function () {
            if (project_page_id) {
                jQuery.sitebuilder.socialNetwork.addViewComment(
                    null,
                    project_page_id
                );
            }
        });

        $('#ahref_fbPhoto').click(function () {
            facebookAPI.checkLogin();
        });

        $('#ahref_fbPagePlugin').click(function () {
            $(RVwys.currentiFrame).focus();
            var spc = $('#fb-page-plugin');
            spc.dialog({
                open: 'true',
                title: rvLang('Page Plugin'),
                modal: true,
                width: '800',
                buttons: [
                    {
                        text: rvLang('Add'),
                        click: function () {
                            var fBody = $('iframe').contents();
                            if (
                                $('div#fb-page-plugin')
                                    .find('input#param_href')
                                    .val()
                                    .match(/https\:\/\/www\.facebook\.com/g) !=
                                'https://www.facebook.com'
                            ) {
                                alert('Please enter Facebook Page URL');
                                return false;
                                //alert(false);
                            }

                            embedPagePlugin($(this), 'add', $(this));
                        },
                    },
                    {
                        text: rvLang('Cancel'),
                        click: function () {
                            $(this).dialog('close');
                        },
                    },
                ],
            });
        });
        /************* page plugin ********************/

        function embedPagePlugin(obj, prefix, selectElement) {
            switch (prefix) {
                case 'add':
                    var urlPagePlugin = $('#param_href').val();
                    var isHideCover;
                    var isFriendsFaces;
                    var isPagePosts;
                    var widthPagePlugin = $('#widthFbPlugin').val();
                    var heightPagePlugin = '130';
                    var likeBoxId = jQuery.md5(String(jQuery.now()));

                    if (widthPagePlugin > 500) {
                        widthPagePlugin = 500;
                    }

                    $('#param_hide_cover').prop('checked')
                        ? (isHideCover = 'true')
                        : (isHideCover = 'false');
                    $('#param_show_facepile').prop('checked')
                        ? (isFriendsFaces = 'true')
                        : (isFriendsFaces = 'false');
                    $('#param_show_posts').prop('checked')
                        ? (isPagePosts = 'true')
                        : (isPagePosts = 'false');

                    var colorscheme = 'light';
                    var bgColor =
                        colorscheme == 'light' ? '#ffffff' : '#333333';

                    var fbOption =
                        '' +
                        'data-href="' +
                        urlPagePlugin +
                        '" ' +
                        'data-width="' +
                        widthPagePlugin +
                        '" data-hide-cover="' +
                        isHideCover +
                        '" data-show-facepile="' +
                        isFriendsFaces +
                        '" ' +
                        'data-show-posts="' +
                        isPagePosts +
                        '"';

                    var strCode =
                        '<img alt="facebook fanpage box" id="fbpageplugin_' +
                        likeBoxId +
                        '" name="fbpageplugin_' +
                        likeBoxId +
                        '"' +
                        ' src="' +
                        parent.wex.url.WYS_IMG_URL +
                        'images/spacer.gif" width="100%"' +
                        ' height="500" border="1" class="fbpageplugin fb_' +
                        colorscheme +
                        '_likebox"' +
                        fbOption;
                    strCode +=
                        ' style="background-color: #ffffff;margin-top:2px;margin-bottom:2px;"';
                    strCode +=
                        ' data="' +
                        Base64.encode(
                            '<div class="fb-page" ' + fbOption + '></div>'
                        ) +
                        '" />';

                    jQuery.sitebuilder.socialNetwork.addToRVwysiwyg(
                        obj,
                        'fblikebox_' + likeBoxId,
                        strCode,
                        'fb-page',
                        fbOption
                    );
                    //RVwys.insertHTML(page_plugin_htmlcode);
                    break;
                case 'edit':
                    alert(typeof selectElement);
                    break;
            }
        }

        /************* end page Plugin*********************/

        /************* button page Plugin *********************/
        $('#frameBody')
            .contents()
            .find('.fbFanPageBlock')
            .has('.fb-page')
            .each(function () {
                fbThis = $(this).find('.fb-page');
                if (fbThis.attr('data') == undefined) {
                    data = Base64.encode($(this).html());
                } else {
                    data = fbThis.attr('data');
                }
                if (fbThis.height() < fbThis.attr('data-height')) {
                    fbHeight = fbThis.attr('data-height');
                } else {
                    fbHeight = '0';
                }
                fbHeight =
                    fbThis.height() < fbThis.attr('data-height')
                        ? fbThis.attr('data-height')
                        : fbThis.height();
                //alert(fbHeight)

                if (fbHeight == '0') {
                    fbHeight = '500';
                }
                //background = (fbThis.attr('data-colorscheme')=='dark')? '#333333' : '#CCCCCC';
                var colorscheme = 'light';
                var bgColor = colorscheme == 'light' ? '#ffffff' : '#333333';

                img =
                    '<img alt="facebook fanpage box"' +
                    'id="' +
                    $(this).get(0).id +
                    '"' +
                    'name="' +
                    $(this).get(0).id +
                    '"' +
                    'class= "fbpageplugin fb_' +
                    colorscheme +
                    '_likebox"' +
                    //	+'style="width:'+fbThis.width()+'px;height:'+fbThis.height()+'px;background-color:'+background+';"'
                    //+'style="width:100%;height:'+fbHeight+';"'
                    //	+'width="'+fbThis.width()+'"'
                    'width="100%"' +
                    'height="' +
                    fbHeight +
                    '"' +
                    'data="' +
                    data +
                    '"' +
                    'data-width="' +
                    fbThis.attr('data-width') +
                    '"' +
                    'data-href="' +
                    fbThis.attr('data-href') +
                    '"' +
                    'data-hide-cover="' +
                    fbThis.attr('data-hide-cover') +
                    '" data-show-facepile="' +
                    fbThis.attr('data-show-facepile') +
                    '" ' +
                    'data-show-posts="' +
                    fbThis.attr('data-show-posts') +
                    '"' +
                    'src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/spacer.gif" />';
                $(this).replaceWith(img);
            });
        /*************end button page Plugin *********************/

        /************* button like*********************/
        $('#frameBody')
            .contents()
            .find('.fbLikeBlock')
            .each(function () {
                fbThis = $(this).find('.fb-like');
                // data-layout="standard" colorscheme="light"
                if (fbThis.attr('data') == undefined) {
                    data = Base64.encode($(this).html());
                } else {
                    data = fbThis.attr('data');
                }
                fbThis.attr('colorscheme');
                img =
                    '<img alt="facebook like"' +
                    'id="' +
                    $(this).get(0).id +
                    '"' +
                    'class= "fbLikebutton fb_light_' +
                    fbThis.attr('data-layout') +
                    '"' +
                    //	+'style="width:'+fbThis.width()+'px;height:'+fbThis.height()+'px;background-color:'+background+';"'
                    //+'style="width:100%;height:'+fbThis.height()+'px;background-color:'+background+';"'
                    //	+'style="width:100%;"'
                    //	+'width="'+fbThis.width()+'"'
                    'width="100%"' +
                    //+'height="'+fbThis.height()+'"'
                    'data="' +
                    data +
                    '"' +
                    'data-send="' +
                    fbThis.attr('data-send') +
                    '"' +
                    'data-layout="' +
                    fbThis.attr('data-layout') +
                    '"' +
                    'data-width="' +
                    fbThis.attr('data-width') +
                    '"' +
                    'data-show-faces="' +
                    fbThis.attr('data-show-faces') +
                    '"' +
                    'data-colorscheme="' +
                    fbThis.attr('data-colorscheme') +
                    '"' +
                    'data-font="' +
                    fbThis.attr('data-font') +
                    '"' +
                    'src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/spacer.gif" />';
                $(this).replaceWith(img);
            });
        /*************end  button like*********************/
        /************* button fanpage *********************/
        $('#frameBody')
            .contents()
            .find('.fbFanPageBlock')
            .each(function () {
                fbThis = $(this).find('.fb-like-box');
                if (fbThis.attr('data') == undefined) {
                    data = Base64.encode($(this).html());
                } else {
                    data = fbThis.attr('data');
                }
                if (fbThis.height() < fbThis.attr('data-height')) {
                    fbHeight = fbThis.attr('data-height');
                } else {
                    fbHeight = '0';
                }
                fbHeight =
                    fbThis.height() < fbThis.attr('data-height')
                        ? fbThis.attr('data-height')
                        : fbThis.height();
                //alert(fbHeight)

                if (fbHeight == '0') {
                    fbHeight = '500';
                }
                background =
                    fbThis.attr('data-colorscheme') == 'dark'
                        ? '#333333'
                        : '#CCCCCC';

                /*
					img = '<img alt="facebook fanpage box"'
					+'id="'+$(this).get(0).id+'"'
					+'name="'+$(this).get(0).id+'"'
					+'class= "fbLikebox fb_'+fbThis.attr('data-colorscheme')+'_likebox"'
				//	+'style="width:'+fbThis.width()+'px;height:'+fbThis.height()+'px;background-color:'+background+';"'
					//+'style="width:100%;height:'+fbHeight+';"'
				//	+'width="'+fbThis.width()+'"'
					+'width="100%"'
					+'height="'+fbHeight+'"'
					+'data="'+data+'"'
					+'data-href="'+fbThis.attr('data-href')+'"'
					+'data-show-faces="'+fbThis.attr('data-show-faces')+'"'
					+'data-colorscheme="'+fbThis.attr('data-colorscheme')+'"'
					+'data-stream="'+fbThis.attr('data-stream')+'"'
					+'data-header="'+fbThis.attr('data-header')+'"'
					+'data-show-border="'+fbThis.attr('data-show-border')+'"'
					+'src="'+parent.wex.url.baseUrl + 'theme/default/images/images/spacer.gif" />'
					 */

                var colorscheme = 'light';
                var bgColor = colorscheme == 'light' ? '#ffffff' : '#333333';

                img =
                    '<img alt="facebook fanpage box"' +
                    'id="stark"' +
                    'name="' +
                    $(this).get(0).id +
                    '"' +
                    'class= " fbpageplugin fb_' +
                    colorscheme +
                    '_likebox"' +
                    //	+'style="width:'+fbThis.width()+'px;height:'+fbThis.height()+'px;background-color:'+background+';"'
                    //+'style="width:100%;height:'+fbHeight+';"'
                    //	+'width="'+fbThis.width()+'"'
                    'width="100%"' +
                    'height="' +
                    fbHeight +
                    '"' +
                    'data="' +
                    data +
                    '"' +
                    'data-width="280"' +
                    'data-href="' +
                    fbThis.attr('data-href') +
                    '"' +
                    'data-hide-cover="false" data-show-facepile="true" ' +
                    'data-show-posts="true"' +
                    'src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/spacer.gif" />';

                $(this).replaceWith(img);
            });
        /*************end button fanpage *********************/
        /*************fbcomment box *********************/
        /*
		 * <img
alt="facebook comment"
id="fbcomment_8ccd3f209b079dbe39638147728ce0b3"
name="fbcomment_8ccd3f209b079dbe39638147728ce0b3"
data-pageid="04bc4eda7d50fbb8dd1c642ce809ee08"
src="/rvsitebuilder54/www/themes/default/sitebuilder/images5/images/spacer.gif"
width="470"
height="300"
border="1"
class="fbComment"
data-num-posts="2"
data-width="470"
data-colorscheme="light"
style="background-color: #ffffff"
/>
		 */
        $('#frameBody')
            .contents()
            .find('.fbCommentsBlock')
            .each(function () {
                fbThis = $(this).find('.fb-comments');
                if (fbThis.attr('data') == undefined) {
                    data = Base64.encode($(this).html());
                } else {
                    data = fbThis.attr('data');
                }
                if (fbThis.get(0).id == '' || fbThis.get(0).id == undefined) {
                    id = $(this).get(0).id;
                } else {
                    id = fbThis.get(0).id;
                }
                if (
                    fbThis.attr('data-pageid') == '' ||
                    fbThis.attr('data-pageid') == undefined
                ) {
                    dataPageid = $(this).attr('data-pageid');
                } else {
                    dataPageid = fbThis.attr('data-pageid');
                }
                fbHeight = fbThis.height();
                if (fbHeight == '0') {
                    fbHeight = 'auto';
                }

                background =
                    fbThis.attr('data-colorscheme') == 'dark'
                        ? '#333333'
                        : '#CCCCCC';
                img =
                    '<img alt="facebook comment"' +
                    'id="' +
                    id +
                    '"' +
                    'name="' +
                    id +
                    '"' +
                    'class= " fbComment fb_comment_' +
                    fbThis.attr('data-colorscheme') +
                    '"' +
                    //	+'style="width:'+fbThis.width()+'px;height:'+fbThis.height()+'px;background-color:'+background+';"'
                    //+'style="width:100%;height:'+fbHeight+';"'
                    //	+'width="'+fbThis.width()+'"'
                    'width="100%"' +
                    'height="' +
                    fbHeight +
                    '"' +
                    'data="' +
                    data +
                    '"' +
                    'data-pageid="' +
                    dataPageid +
                    '"' +
                    'data-num-posts="' +
                    fbThis.attr('data-num-posts') +
                    '"' +
                    'data-width="' +
                    fbThis.attr('data-width') +
                    '"' +
                    'data-colorscheme="' +
                    fbThis.attr('data-colorscheme') +
                    '"' +
                    'src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/spacer.gif" />';
                $(this).replaceWith(img);
            });
        /*************end fbcomment box *********************/

        function insertPhotoFacebook(pasteHtmlcode) {
            var wrapPasteHtml =
                '<div id="pasteElement">' + pasteHtmlcode + '</div>';
            RVwys.insertHTML(wrapPasteHtml);
            fBody.find('#pasteElement').contents().unwrap();
        }

        /************ Image page plugin Toggle from option ******************/
        $('#param_hide_cover').click(function () {
            RVwys.pagePluginToggleImage(
                $('#param_hide_cover').prop('checked'),
                $('#param_show_facepile').prop('checked'),
                $('#param_show_posts').prop('checked')
            );
        });

        $('#param_show_facepile').click(function () {
            RVwys.pagePluginToggleImage(
                $('#param_hide_cover').prop('checked'),
                $('#param_show_facepile').prop('checked'),
                $('#param_show_posts').prop('checked')
            );
        });

        $('#param_show_posts').click(function () {
            RVwys.pagePluginToggleImage(
                $('#param_hide_cover').prop('checked'),
                $('#param_show_facepile').prop('checked'),
                $('#param_show_posts').prop('checked')
            );
        });
        /************End Image page plugin Toggle from option ******************/
    });

    $(document).bind('editorDesign', function (event) {
        event.hol = data = $('<div/>')
            .append(event.hol.html())
            .find('.fbComment, .fbLikebox, .fbLikebutton, .fbpageplugin')
            .each(function () {
                //alert($(this).parent().html())
                background =
                    $(this).attr('data-colorscheme') == 'dark'
                        ? '#333333'
                        : '#CCCCCC';
                // alert(altTarget)
                altTarget = $(this).attr('alt');
                switch (altTarget) {
                    case 'facebook like':
                        cDisplay = 'fb_light_' + $(this).attr('data-layout');
                        $(this).removeClass('sprite_wysiwyg wys-like');

                        $(this).replaceWith(
                            '&lt;img ' +
                                'alt="' +
                                altTarget +
                                '"' +
                                'id="' +
                                $(this).attr('id') +
                                '"' +
                                'src="' +
                                $(this)
                                    .attr('src')
                                    .replace(
                                        '/icon_jotform.jpg',
                                        '/spacer.gif'
                                    ) +
                                '"' +
                                'border="1"' +
                                'class="' +
                                $(this).get(0).className.replace(cDisplay, '') +
                                ' ' +
                                cDisplay +
                                '"' +
                                'data-send="' +
                                $(this).attr('data-send') +
                                '"' +
                                'data-layout="' +
                                $(this).attr('data-layout') +
                                '"' +
                                'data-width="' +
                                $(this).attr('data-width') +
                                '"' +
                                'data-show-faces="true"' +
                                'data-colorscheme="' +
                                $(this).attr('data-colorscheme') +
                                '"' +
                                //fbLikebutton fb_light_'+fbThis.attr('data-layout')
                                //	 +'width="'+$(this).attr('defaultWidth')+'"'
                                'width="100%"' +
                                'height="' +
                                $(this).attr('height') +
                                '"' +
                                'data="' +
                                $(this).attr('data') +
                                '"' +
                                //	 +'style="width:'+$(this).attr('defaultWidth')+'px;height:'+$(this).attr('defaultHeight')+'px;background-color:'+background+';"/&gt;'
                                '/&gt;'
                        );
                        break;
                    case 'facebook fanpage box':
                        cDisplay =
                            'fb_' +
                            $(this).attr('data-colorscheme') +
                            '_likebox';
                        $(this).removeClass('sprite_wysiwyg wys-fb');

                        $(this).replaceWith(
                            '&lt;img ' +
                                'alt="' +
                                altTarget +
                                '"' +
                                'id="' +
                                $(this).attr('id') +
                                '"' +
                                'name="' +
                                $(this).attr('id') +
                                '"' +
                                'src="' +
                                $(this)
                                    .attr('src')
                                    .replace(
                                        '/icon_jotform.jpg',
                                        '/spacer.gif'
                                    ) +
                                '"' +
                                'class="' +
                                $(this).get(0).className.replace(cDisplay, '') +
                                ' ' +
                                cDisplay +
                                '"' +
                                'width="100%"' +
                                'height="500"' +
                                'data="' +
                                $(this).attr('data') +
                                '"' +
                                'data-width="' +
                                $(this).attr('data-width') +
                                '"' +
                                'data-href="' +
                                $(this).attr('data-href') +
                                '"' +
                                'data-hide-cover="' +
                                $(this).attr('data-hide-cover') +
                                '" data-show-facepile="' +
                                $(this).attr('data-show-facepile') +
                                '" ' +
                                'data-show-posts="' +
                                $(this).attr('data-show-posts') +
                                '"' +
                                //	 +'style="width:'+$(this).attr('defaultWidth')+'px;height:'+$(this).attr('defaultHeight')+'px;background-color:'+background+';"/&gt;'
                                '/&gt;'
                        );

                        break;
                    case 'facebook comment':
                        cDisplay =
                            'fb_comment_' + $(this).attr('data-colorscheme');
                        $(this).removeClass('sprite_wysiwyg wys-fbcomment');

                        $(this).replaceWith(
                            '&lt;img ' +
                                'alt="' +
                                altTarget +
                                '"' +
                                'id="' +
                                $(this).attr('id') +
                                '"' +
                                'name="' +
                                $(this).attr('id') +
                                '"' +
                                'src="' +
                                $(this)
                                    .attr('src')
                                    .replace(
                                        '/icon_jotform.jpg',
                                        '/spacer.gif'
                                    ) +
                                '"' +
                                'class="' +
                                $(this).get(0).className.replace(cDisplay, '') +
                                ' ' +
                                cDisplay +
                                '"' +
                                'width="100%"' +
                                'height="' +
                                $(this).attr('height') +
                                '"' +
                                'data="' +
                                $(this).attr('data') +
                                '"' +
                                'data-pageid="' +
                                $(this).attr('data-pageid') +
                                '"' +
                                'data-num-posts="' +
                                $(this).attr('data-num-posts') +
                                '"' +
                                'data-width="' +
                                $(this).attr('data-width') +
                                '"' +
                                'data-colorscheme="' +
                                $(this).attr('data-colorscheme') +
                                '"' +
                                //	 +'style="width:'+$(this).attr('defaultWidth')+'px;height:'+$(this).attr('defaultHeight')+'px;background-color:'+background+';"/&gt;'
                                '/&gt;'
                        );

                        break;
                    default:
                        cDisplay = '';
                        break;
                }
                var thisHTML = $(this)[0].outerHTML;
                console.log(
                    'this HTML Icon------>' +
                        Base64.decode($(this).attr('data'))
                );
            })
            .end();
        data.remove();
    });
    $(document).bind('editorSource', function (event) {
        event.hol
            .find('.fbComment, .fbLikebox, .fbLikebutton, .fbpageplugin')
            .each(function () {
                if ($(this).hasClass('fbLikebutton')) {
                    classFB = 'sprite_wysiwyg wys-like';
                } else if ($(this).hasClass('fbLikebox')) {
                    classFB = 'sprite_wysiwyg wys-fb';
                } else if ($(this).hasClass('fbComment')) {
                    classFB = 'sprite_wysiwyg wys-fbcomment';
                } else if ($(this).hasClass('fbpageplugin')) {
                    classFB = 'sprite_wysiwyg wys-fb';
                }
                $(this)
                    .attr({
                        src: parent.wex.url.WYS_IMG_URL + 'images/spacer.gif',
                        width: '21',
                        height: '21',
                        defaultWidth: $(this).width(),
                        defaultHeight: $(this).height(),
                    })
                    .css({ width: '21px', height: '21px' })
                    .addClass(classFB);
            });
    });
    $(document).bind('editorClose', function () {
        /*
		$('body').find('.imgFacebookLike').each(function(){

			 var getHref = jQuery(this).attr('cmdHref');
			 var getDataLayout = jQuery(this).attr('cmdDataLayout');
			 var getDataAction = jQuery(this).attr('cmdDataAction');
			 var getDataShowFace = jQuery(this).attr('cmdDataShowFace');
			 var getDataShare = jQuery(this).attr('cmdDataShare');
			 var getDataWidth = jQuery(this).attr('cmdDataWidth');

			 jQuery(this).after('<div class="fb-like" data-href="'+getHref+'" data-width="'+getDataWidth+'" data-layout="'+getDataLayout+'" data-action="'+getDataAction+'" data-show-faces="'+getDataShowFace+'" data-share="'+getDataShare+'"></div>');
		});
		*/
        //$('#facebook-jssdk').replaceWith($('#facebook-jssdk'))
        /*************end button like*********************/
    });

    RVwys.pagePluginToggleImage = function (hideCover, showFace, showPost) {
        if (hideCover == true && showFace == true && showPost == true) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_dontcover.jpg'
            );
        } else if (hideCover == false && showFace == true && showPost == true) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_checkall.jpg'
            );
        } else if (
            hideCover == false &&
            showFace == false &&
            showPost == true
        ) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_dontfriend.jpg'
            );
        } else if (
            hideCover == false &&
            showFace == true &&
            showPost == false
        ) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_dontpost.jpg'
            );
        } else if (
            hideCover == true &&
            showFace == false &&
            showPost == false
        ) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_dontchkall.jpg'
            );
        } else if (hideCover == true && showFace == true && showPost == false) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_friendonly.jpg'
            );
        } else if (hideCover == true && showFace == false && showPost == true) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_postonly.jpg'
            );
        } else if (
            hideCover == false &&
            showFace == false &&
            showPost == false
        ) {
            $('img#add_likebox').attr(
                'src',
                parent.wex.url.baseUrl +
                    'theme/default/images/fb_page_coveronly.jpg'
            );
        }

        return true;
    };

    RVwys.widget.facebook = {};
    RVwys.widget.facebook.elementReceive = function (oThis, e, ui) {
        RVwys.widget.facebook.Receive(oThis, e, ui, 'elementReceive');
    };
    RVwys.widget.facebook.sectionReceive = function (oThis, e, ui) {
        RVwys.widget.facebook.Receive(oThis, e, ui, 'sectionReceive');
    };
    RVwys.widget.facebook.Receive = function (oThis, e, ui, isWhere) {
        //alert('section')
        ui.sender.data('copied', true);
        //ui.item.replaceWith("<div>Facebook</div>");
        var typeFacebookNum = ui.item.attr('fbValue');
        var placeHoleFB;
        var id = jQuery.md5(String(jQuery.now()));
        var d = new Date();
        /*
		$('body').find('.imgFacebookLike').each(function(){

			 var getHref = jQuery(this).attr('cmdHref');
			 var getDataLayout = jQuery(this).attr('cmdDataLayout');
			 var getDataAction = jQuery(this).attr('cmdDataAction');
			 var getDataShowFace = jQuery(this).attr('cmdDataShowFace');
			 var getDataShare = jQuery(this).attr('cmdDataShare');
			 var getDataWidth = jQuery(this).attr('cmdDataWidth');

			 jQuery(this).after('<div class="fb-like" data-href="'+getHref+'" data-width="'+getDataWidth+'" data-layout="'+getDataLayout+'" data-action="'+getDataAction+'" data-show-faces="'+getDataShowFace+'" data-share="'+getDataShare+'"></div>');
		});
		*/
        //$('#facebook-jssdk').replaceWith($('#facebook-jssdk'))

        /*************end button like*********************/

        var n = d.getTime();
        var urlfb = 'http://social.rvsitebuilder.com/facebook/fb/' + n;
        switch (typeFacebookNum) {
            case '1':
                var typeFacebookStr = 'Facebook_Like';
                var iframeForWys =
                    '<div class="fb-like" ' +
                    'data-href ="' +
                    $(this).attr('cmdhref') +
                    '" ' +
                    'data-width="320" ' +
                    'data-layout="button_count" ' +
                    'data-action="like"' +
                    'data-size="small" ' +
                    'data-show-faces="true" ' +
                    'data-share="true">' +
                    '</div>';

                placeHoleFB =
                    '<div class="rv-ribbon"></div><img src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/spacer.gif' +
                    '"';
                placeHoleFB += 'id="' + id + '"';

                placeHoleFB += 'class="imgFacebookLike"';
                placeHoleFB += 'align="center"';
                placeHoleFB += 'formtype="' + typeFacebookStr + '"';
                placeHoleFB += 'cmdHref="' + urlfb + '"';
                placeHoleFB += 'cmdDataWidth="320"';
                placeHoleFB += 'cmdDataLayout="button_count"';
                placeHoleFB += 'cmdDataAction="like"';
                placeHoleFB += 'cmdDataShowFace="true"';
                placeHoleFB += 'cmdDataShare="true"';
                placeHoleFB += 'cmdPreviewWys="' + btoa(iframeForWys) + '"';
                if (isWhere == 'elementReceive') {
                    placeHoleFB +=
                        'style="margin-top:2px;margin-bottom:2px;width:160px;height:21px;border:1px solid #ccc;"';
                } else {
                    placeHoleFB +=
                        'style="margin-top:2px;margin-bottom:2px;margin-left:3px;margin-right:3px;width:98.5%;height:30px;"';
                }
                //placeHoleFB += 'style="margin-top:2px;margin-bottom:2px;width:100%;height:px;"';
                placeHoleFB +=
                    'onclick="RVwys.widget.facebook.showleftMenu(this)">';

                break;

            case '2':
                var typeFacebookStr = 'Facebook_Comment';

                var iframeForWys =
                    '<div class="fb-comments" ' +
                    'data-href ="' +
                    urlfb +
                    '" ' +
                    'data-width="100%" ' +
                    'data-numposts="5">' +
                    '</div>';

                placeHoleFB =
                    '<div class="rv-ribbon"></div><img src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/spacer.gif' +
                    '"';
                placeHoleFB += 'id="' + id + '"';
                placeHoleFB += 'class="imgFacebookComment"';
                placeHoleFB += 'formtype="' + typeFacebookStr + '"';
                placeHoleFB += 'align="center"';
                placeHoleFB += 'cmdHref="' + urlfb + '"';
                placeHoleFB += 'cmdWidth="100%"';
                placeHoleFB += 'cmdNumpost="5"';
                placeHoleFB += 'cmdPreviewWys="' + btoa(iframeForWys) + '"';
                if (isWhere == 'elementReceive') {
                    placeHoleFB +=
                        'style="width:100%;height:193px;margin-top:2px;margin-bottom:2px;margin-left:3px;margin-right:3px;"';
                } else {
                    placeHoleFB +=
                        'style="width:100%;height:193px;margin-top:2px;margin-bottom:2px;margin-left:3px;margin-right:3px;"';
                }
                placeHoleFB +=
                    'onclick="RVwys.widget.facebook.showleftMenu(this)">';

                break;

            case '3':
                var iframeForWys =
                    "<iframe width='100%' height='1000px' frameborder='0' allowtransparency='true' allowfullscreen='true' scrolling='no' src='https://www.facebook.com/v18.0/plugins/page.php?adapt_container_width=true&amp;container_width=613&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2Ffacebook&amp;locale=en_US&amp;sdk=joey&amp;show_facepile=false&amp;small_header=false&amp;tabs=timeline' style='border: none; visibility: visible; width: 100%; max-width: 100%; height: 500px;'></iframe>";

                var typeFacebookStr = 'Facebook_page';
                placeHoleFB =
                    '<div class="rv-ribbon"></div><img src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/spacer.gif' +
                    '"';
                placeHoleFB += 'id="' + id + '"';
                placeHoleFB += 'class="imgFacebookPage"';
                placeHoleFB += 'align="center"';
                placeHoleFB += 'formtype="' + typeFacebookStr + '"';
                placeHoleFB += 'cmdHref="https://www.facebook.com/facebook"';
                placeHoleFB += 'cmdWidth="260"';
                placeHoleFB += 'cmdHeight="550"';
                placeHoleFB += 'cmdSmallHeader="false"';
                placeHoleFB += 'cmdAdaptContainerWidth="true"';
                placeHoleFB += 'cmdHidCover="false"';
                placeHoleFB += 'cmdShowFaceFri="true"';
                placeHoleFB += 'cmdTabs="timeline"';
                placeHoleFB += 'cmdPreviewWys="' + btoa(iframeForWys) + '"';
                if (isWhere == 'elementReceive') {
                    placeHoleFB +=
                        'style="width:260px;height:550px;margin-top:2px;margin-bottom:2px;margin-left:3px;margin-right:3px;"';
                } else {
                    placeHoleFB +=
                        'style="width:100%;height:auto;margin-top:2px;margin-bottom:2px;margin-left:3px;margin-right:3px; /*filter:grayscale(80%)*/;"';
                }
                placeHoleFB +=
                    'onclick="RVwys.widget.facebook.showleftMenu(this)">';

                break;

            default:
                var placeHoleFB = '<div>Facebook</div>';
                console.log('error type facebook widget secion Receive');
        }
        var predsFB = '';
        if (isWhere == 'elementReceive') {
            predsFB = 'element';
        }
        if (typeFacebookNum == 3 && ui.item.attr('columns') == 2) {
            //			alert('.' + predsFB + 'designWidgetFacebook_2_columns')
            //			alert(ui.item.attr('target'))
            var designWidgetFacebook = $(
                '.' + predsFB + 'designWidgetFacebook_2_columns'
            ).html();
            if (ui.item.attr('target') != undefined) {
                //				alert($('.' + predsFB + ui.item.attr('target')).html())
                designWidgetFacebook = $(
                    '.' + predsFB + ui.item.attr('target')
                ).html();
            }

            designWidgetFacebook = designWidgetFacebook
                .replace(/#NAME#/gim, typeFacebookStr)
                .replace(/#IMAGE#/gim, placeHoleFB)
                .replace('#widgetFBMenuBar#', 'widgetFBMenuBar navMenuAll')
                .replace(
                    '#widgetFBProperties#',
                    'widgetFBProperties navMenuAll'
                );
        } else {
            designWidgetFacebook = $('.' + predsFB + 'designWidgetFacebook')
                .html()
                .replace(/#NAME#/gim, typeFacebookStr)
                .replace(/#IMAGE#/gim, placeHoleFB)
                .replace('#widgetFBMenuBar#', 'widgetFBMenuBar navMenuAll')
                .replace(
                    '#widgetFBProperties#',
                    'widgetFBProperties navMenuAll'
                );
        }

        //alert(designWidgetFacebook)
        ui.item.replaceWith(designWidgetFacebook);
        $(oThis).parent().find('.dropHere').remove();

        setTimeout(function () {
            RVwys.widget.facebook.showleftMenu($('#' + id));
            var oMG = RVwys.getParentByClass($('#' + id), 'mg');
            var tFoCus = $('.mgActive').eq(0);
            $('html, body').animate(
                {
                    scrollTop: tFoCus.offset().top,
                },
                1000,
                function () {
                    tFoCus.get(0).focus();
                }
            );
            RVwys.currentEditor = document;
            RVwys.currentiFrame = tFoCus.get(0);
            //alert(tFoCus..find('.RVWYSIWYGAREA'))

            RVwys.UIgridSortable(oMG);
            RVwys.uikit.blockprop.eventEditFocus(tFoCus);

            $('.mgwidget').mousedown(function () {
                //RVwys.eventMG($(this));
            });
        }, 100);
    };

    RVwys.widget.facebook.showleftMenu = function (oThis) {
        //parent.$( ".background-prop" ).tabs("option", "active", 1 );
        //parent.$( ".background-prop" ).tabs( "disable", 0 );
        var mg = RVwys.getParentByClass($(oThis), 'mg');
        var mgDesignBlock = RVwys.getParentByClass(
            $(oThis),
            'rvsb_design_block'
        );
        parent.RVwys.targetAnimatObj = mgDesignBlock; // this use animattion set see plugin animation
        RVwys.setDefaultAnimation(mgDesignBlock);
        parent.RVwys.showPanelWidgetBlock(oThis);
        $('.blockTools').remove();
        $('.mgActive').removeClass('mgActive');
        mgDesignBlock.addClass('mgActive');
        $('.navMenuAll').hide();

        if (!mg.find('.widgetFBMenuBar').get(0)) {
            var wfp = $('.wfbp').clone();
            wfp.get(0).className = 'widgetFBMenuBar navMenuAll';
            mgDesignBlock.prepend(wfp);
        }

        mg.find('.widgetFBMenuBar').show();
    };

    RVwys.widget.facebook.showProp = function (oThis) {
        console.log('test ::::' + $(oThis).prop('tagNames'));
        var getTypeFacebook = $(oThis)
            .closest('div.mgwidget')
            .find('.imgFacebookLike,.imgFacebookComment,.imgFacebookPage')
            .attr('class');
        //alert($(oThis).closest('div.mgwidget').find('.imgFacebookLike,.imgFacebookComment,.imgFacebookPage'))
        //alert(getTypeFacebook)
        switch (getTypeFacebook) {
            case 'imgFacebookLike':
                getTypeFacebook = 'Facebook Like';
                RVwys.widget.facebook.showDialogFbLike($(oThis));
                break;
            case 'imgFacebookComment':
                getTypeFacebook = 'Facebook Comment';
                RVwys.widget.facebook.showDialogFbComment($(oThis));
                break;
            case 'imgFacebookPage':
                getTypeFacebook = 'Facebook Page';
                RVwys.widget.facebook.showDialogFbPage($(oThis));
                break;
            default:
                getTypeFacebook = 'Facebook';
                console.log('not type facebook');
        }
        /*
		 var mg = RVwys.getParentByClass($(oThis),'mg');
		 $('.navMenuAll').hide();
		 if ( mg.find('.widgetFBProperties').get(0)) {
			 mg.find('.widgetFBProperties').show();
		 } else {
			 var wfb = $('.wfb').clone();
			 wfb.get(0).className = 'widgetFBProperties navMenuAll';
			 wfb.find('.widgetFormName').html(getTypeFacebook);
			 wfb.find('#editFormFbUikit').attr('onclick',eventClickEdit);
			 mg.prepend(wfb);
			 mg.find('.widgetFBProperties').show();
		 }
		 */
    };

    RVwys.widget.facebook.showDialogFbLike = function (oThis) {
        parent.$('#editFacebookLikeUikit').remove();
        var getHtml = $('#editFacebookLikeUikit').parent().html();
        const $getDivForm = parent.$(getHtml);
        var getElementEdit = oThis
            .closest('div.mgwidget')
            .find('.imgFacebookLike');

        var getUrl = getElementEdit.attr('cmdHref');
        var getWidth = getElementEdit.attr('cmdDataWidth');
        var getLayout = getElementEdit.attr('cmdDataLayout');
        var getActionType = getElementEdit.attr('cmdDataAction');
        var getShowFace = getElementEdit.attr('cmdDataShowFace');
        var getIncludeShare = getElementEdit.attr('cmdDataShare');
        var getIdForSave = getElementEdit.attr('id');

        $getDivForm.find('#fb-like').addClass('fb-like').attr({
            'data-href': getUrl,
            'data-width': getWidth,
            'data-layout': getLayout,
            'data-action': getActionType,
            'data-show-faces': getShowFace,
            'data-share': getIncludeShare,
        });
        //save ค่า id img เอาไว้ตอน save edit
        $getDivForm
            .find('#saveEditFacebookLikeUIkit')
            .attr('cmdIdImg', getIdForSave);

        $getDivForm.find('#urlFacebookLike').val(getUrl);
        $getDivForm.find('#widthFacebookLike').val(getWidth);
        $getDivForm.find('#layoutFacebookLike').val(getLayout);
        $getDivForm.find('#typeFacebookLike').val(getActionType);
        if (getShowFace == 'true') {
            $getDivForm.find('#showFaceFacebookLike').prop('checked', true);
        } else {
            $getDivForm.find('#showFaceFacebookLike').prop('checked', false);
        }

        if (getIncludeShare == 'true') {
            $getDivForm.find('#shareFacebookLike').prop('checked', true);
        } else {
            $getDivForm.find('#shareFacebookLike').prop('checked', false);
        }

        $getDivForm.dialog({
            open: 'true',
            title: 'Facebook Like Button Settings',
            width: '780px',

            resize: true,
            modal: true,
            open: function (event, ui) {
                parent.FB.XFBML.parse();
            },
        });
        jQuery('div.widgetFBProperties').hide();
    };

    RVwys.widget.facebook.showDialogFbComment = function (oThis) {
        parent.$('#editFacebookCommentUikit').remove();
        var getHtml = $('#editFacebookCommentUikit').parent().html();
        const $getDivForm = parent.$(getHtml);

        var getElementEdit = oThis
            .closest('div.mgwidget')
            .find('.imgFacebookComment');

        var getUrl = getElementEdit.attr('cmdHref');
        var getWidth = getElementEdit.attr('cmdWidth');
        var getNumPost = getElementEdit.attr('cmdNumpost');
        var getIdForSave = getElementEdit.attr('id');
        // alert(getUrl);
        if (getUrl == '') {
            var d = new Date();
            var n = d.getTime();
            getUrl = window.location.href + '/fb/' + n;
        }

        $getDivForm.find('#fb-comments').addClass('fb-comments').attr({
            'data-href': getUrl,
            'data-width': getWidth,
            'data-numposts': getNumPost,
        });
        //save ค่า id img เอาไว้ตอน save edit
        $getDivForm
            .find('#saveEditFacebookCommentsUIkit')
            .attr('cmdIdImg', getIdForSave);

        $getDivForm.find('#urlFacebookComment').val(getUrl);
        $getDivForm.find('#widthFacebookComment').val(getWidth);
        $getDivForm.find('#numpostFacebookComment').val(getNumPost);
        $getDivForm.dialog({
            open: 'true',
            title: 'Facebook Comments Settings',
            width: '780px',
            resize: true,
            modal: true,
            open: function (event, ui) {
                parent.FB.XFBML.parse();
            },
        });

        jQuery('div.widgetFBProperties').hide();
    };

    RVwys.widget.facebook.showDialogFbPage = function (oThis) {
        parent.$('#editFacebookPageUikit').remove();
        var getHtml = $('#editFacebookPageUikit').parent().html();
        var getDivForm = parent.$(getHtml);

        var getElementEdit = oThis
            .closest('div.mgwidget')
            .find('.imgFacebookPage');

        var getUrl = getElementEdit.attr('cmdHref');
        var getWidth = getElementEdit.attr('cmdWidth');
        var getHeight = getElementEdit.attr('cmdHeight');
        var getSmallHeader = getElementEdit.attr('cmdSmallHeader');
        var getAdaptContainerWidth = getElementEdit.attr(
            'cmdAdaptContainerWidth'
        );
        var getHidCover = getElementEdit.attr('cmdHidCover');
        var getShowFaceFri = getElementEdit.attr('cmdShowFaceFri');
        var getTabs = getElementEdit.attr('cmdTabs');
        var getIdForSave = getElementEdit.attr('id');

        getDivForm.find('#fb-page').addClass('fb-page').attr({
            'data-href': getUrl,
            'data-width': getWidth,
            'data-heigth': getHeight,
            'data-small-header': getSmallHeader,
            'data-adapt-container-width': getAdaptContainerWidth,
            'data-hide-cover': getHidCover,
            'data-show-facepile': getShowFaceFri,
            'data-tabs': getTabs,
        });
        //save ค่า id img เอาไว้ตอน save edit
        getDivForm
            .find('#saveEditFacebookPageUIkit')
            .attr('cmdIdImg', getIdForSave);

        getDivForm.find('#urlFacebookPage').val(getUrl);
        getDivForm.find('#tabsFacebookPage').val(getTabs);
        getDivForm.find('#widthFacebookPage').val(getWidth);
        getDivForm.find('#heightFacebookPage').val(getHeight);

        if (getSmallHeader == 'true') {
            getDivForm.find('#smallheaderFacebookPage').prop('checked', true);
        } else {
            getDivForm.find('#smallheaderFacebookPage').prop('checked', false);
        }

        if (getAdaptContainerWidth == 'true') {
            getDivForm
                .find('#containerwidthFacebookPage')
                .prop('checked', true);
        } else {
            getDivForm
                .find('#containerwidthFacebookPage')
                .prop('checked', false);
        }

        if (getHidCover == 'true') {
            getDivForm.find('#hidcoverFacebookPage').prop('checked', true);
        } else {
            getDivForm.find('#hidcoverFacebookPage').prop('checked', false);
        }

        if (getShowFaceFri == 'true') {
            getDivForm.find('#showfriendFacebookPage').prop('checked', true);
        } else {
            getDivForm.find('#showfriendFacebookPage').prop('checked', false);
        }

        getDivForm.dialog({
            open: 'true',
            title: 'Facebook Page Settings',
            width: '780px',
            resize: true,
            modal: true,
            open: function (event, ui) {
                parent.FB.XFBML.parse();
            },
        });
        jQuery('div.widgetFBProperties').hide();
    };

    RVwys.widget.facebook.editFbLike = function () {
        const $getDivForm = parent.jQuery('#editFacebookLikeUikit');
        $getDivForm
            .find('#fb-like')
            .empty()
            .removeAttr('fb-xfbml-state fb-iframe-plugin-query class');
        setTimeout(function () {
            //$getDivForm.find('div.show-icon').append('<div id="fb-like"></div>');

            //get value from input
            var getUrl = $getDivForm.find('#urlFacebookLike').val();
            var getWidth = $getDivForm.find('#widthFacebookLike').val();
            var getLayout = $getDivForm.find('#layoutFacebookLike').val();
            var getActionType = $getDivForm.find('#typeFacebookLike').val();
            var getShowFace = $getDivForm
                .find('#showFaceFacebookLike')
                .prop('checked');
            var getIncludeShare = $getDivForm
                .find('#shareFacebookLike')
                .prop('checked');

            getShowFace ? (getShowFace = 'true') : (getShowFace = 'false');
            getIncludeShare
                ? (getIncludeShare = 'true')
                : (getIncludeShare = 'false');

            $getDivForm.find('#fb-like').addClass('fb-like').attr({
                'data-href': getUrl,
                'data-width': getWidth,
                'data-layout': getLayout,
                'data-action': getActionType,
                'data-show-faces': getShowFace,
                'data-share': getIncludeShare,
            });
        }, 50);

        setTimeout(function () {
            parent.FB.XFBML.parse();
        }, 100);
    };

    RVwys.widget.facebook.editFbComments = function () {
        const getDivForm = parent.jQuery('#editFacebookCommentUikit');
        getDivForm.find('#fb-root').remove();
        getDivForm.find('#fb-comments').remove();
        setTimeout(function () {
            getDivForm
                .find('div.show-icon')
                .append('<div id="fb-comments"></div>');

            //get value from input
            var getUrl = getDivForm.find('#urlFacebookComment').val();
            var getWidth = getDivForm.find('#widthFacebookComment').val();
            var getNumpost = getDivForm.find('#numpostFacebookComment').val();
            //alert(getUrl)
            getDivForm.find('#fb-comments').addClass('fb-comments').attr({
                'data-href': getUrl,
                'data-width': getWidth,
                'data-numposts': getNumpost,
            });
        }, 50);

        setTimeout(function () {
            parent.FB.XFBML.parse();
        }, 1000);
    };

    RVwys.widget.facebook.editFbPage = function () {
        const getDivForm = parent.jQuery('#editFacebookPageUikit');
        getDivForm.find('#fb-page').remove();
        setTimeout(function () {
            getDivForm.find('div.show-icon').append('<div id="fb-page"></div>');

            //get value from input
            var getUrl = getDivForm.find('#urlFacebookPage').val();
            var getTabs = getDivForm.find('#tabsFacebookPage').val();
            var getWidth = getDivForm.find('#widthFacebookPage').val();
            var getHeight = getDivForm.find('#heightFacebookPage').val();
            var getSmallHeader = getDivForm
                .find('#smallheaderFacebookPage')
                .prop('checked');
            var getAdaptContainerWidth = getDivForm
                .find('#containerwidthFacebookPage')
                .prop('checked');

            var getHidCover = getDivForm
                .find('#hidcoverFacebookPage')
                .prop('checked');
            var getShowFaceFri = getDivForm
                .find('#showfriendFacebookPage')
                .prop('checked');

            getSmallHeader
                ? (getSmallHeader = 'true')
                : (getSmallHeader = 'false');
            getAdaptContainerWidth
                ? (getAdaptContainerWidth = 'true')
                : (getAdaptContainerWidth = 'false');
            getHidCover ? (getHidCover = 'true') : (getHidCover = 'false');
            getShowFaceFri
                ? (getShowFaceFri = 'true')
                : (getShowFaceFri = 'false');

            getDivForm.find('#fb-page').addClass('fb-page').attr({
                'data-href': getUrl,
                'data-width': getWidth,
                'data-heigth': getHeight,
                'data-small-header': getSmallHeader,
                'data-adapt-container-width': getAdaptContainerWidth,
                'data-hide-cover': getHidCover,
                'data-show-facepile': getShowFaceFri,
                'data-tabs': getTabs,
            });
        }, 50);

        setTimeout(function () {
            parent.FB.XFBML.parse();
        }, 100);
    };

    RVwys.widget.facebook.saveFblike = function (jThis) {
        // get img for save eidt
        var imgPlaceHolderFbLike = jQuery('#' + jThis.attr('cmdIdImg'));

        //get value from edit input สำหรับ save edit
        var getUrl = getDivForm.find('#urlFacebookLike').val();
        var getWidth = getDivForm.find('#widthFacebookLike').val();
        var getLayout = getDivForm.find('#layoutFacebookLike').val();
        var getActionType = getDivForm.find('#typeFacebookLike').val();
        var getShowFace = getDivForm
            .find('#showFaceFacebookLike')
            .prop('checked');
        var getIncludeShare = getDivForm
            .find('#shareFacebookLike')
            .prop('checked');

        var getPreview = getDivForm.find('div.fb-like > span').html();
        getPreview = btoa(getPreview);

        getShowFace ? (getShowFace = 'true') : (getShowFace = 'false');
        getIncludeShare
            ? (getIncludeShare = 'true')
            : (getIncludeShare = 'false');

        imgPlaceHolderFbLike.attr({
            cmdHref: getUrl,
            cmdDataWidth: getWidth,
            cmdDataLayout: getLayout,
            cmdDataAction: getActionType,
            cmdDataShowFace: getShowFace,
            cmdDataShare: getIncludeShare,
            cmdPreviewWys: getPreview,
        });

        getDivForm.dialog('close');
    };

    RVwys.widget.facebook.saveFbComments = function (jThis) {
        // get img for save eidt
        var imgPlaceHolderFbComment = jQuery('#' + jThis.attr('cmdIdImg'));

        //get value from edit input สำหรับ save edit
        var getUrl = getDivForm.find('#urlFacebookComment').val();
        var getWidth = getDivForm.find('#widthFacebookComment').val();
        var getNumpost = getDivForm.find('#numpostFacebookComment').val();

        iframeForWys =
            ' <div class="fb-comments" ' +
            'data-href ="' +
            getUrl +
            '" ' +
            'data-width="' +
            getWidth +
            '" ' +
            'data-numposts="' +
            getNumpost +
            '">' +
            '</div>';

        iframeForWys = btoa(iframeForWys);
        imgPlaceHolderFbComment.attr({
            cmdHref: getUrl,
            cmdWidth: getWidth,
            cmdNumpost: getNumpost,
            cmdPreviewWys: iframeForWys,
        });

        getDivForm.dialog('close');
    };

    RVwys.widget.facebook.saveFbPage = function (jThis) {
        // get img for save eidt
        var imgPlaceHolderFbPage = jQuery('#' + jThis.attr('cmdIdImg'));

        //get value from input
        var getUrl = getDivForm.find('#urlFacebookPage').val();
        var getTabs = getDivForm.find('#tabsFacebookPage').val();
        var getWidth = getDivForm.find('#widthFacebookPage').val();
        var getHeight = getDivForm.find('#heightFacebookPage').val();
        var getSmallHeader = getDivForm
            .find('#smallheaderFacebookPage')
            .prop('checked');
        var getAdaptContainerWidth = getDivForm
            .find('#containerwidthFacebookPage')
            .prop('checked');
        var getHidCover = getDivForm
            .find('#hidcoverFacebookPage')
            .prop('checked');
        var getShowFaceFri = getDivForm
            .find('#showfriendFacebookPage')
            .prop('checked');

        var getPreview = getDivForm.find('div.fb-page > span').html();
        getPreview = btoa(getPreview);

        getSmallHeader ? (getSmallHeader = 'true') : (getSmallHeader = 'false');
        getAdaptContainerWidth
            ? (getAdaptContainerWidth = 'true')
            : (getAdaptContainerWidth = 'false');
        getHidCover ? (getHidCover = 'true') : (getHidCover = 'false');
        getShowFaceFri ? (getShowFaceFri = 'true') : (getShowFaceFri = 'false');

        imgPlaceHolderFbPage.attr({
            cmdHref: getUrl,
            cmdWidth: getWidth,
            cmdHeight: getHeight,
            cmdSmallHeader: getSmallHeader,
            cmdAdaptContainerWidth: getAdaptContainerWidth,
            cmdHidCover: getHidCover,
            cmdShowFaceFri: getShowFaceFri,
            cmdTabs: getTabs,
            cmdPreviewWys: getPreview,
        });

        getDivForm.dialog('close');
    };

    $(document).bind('designReady', function (e) {
        if ($('#widgetFacebook').hasClass('ui-sortable')) {
            $('#widgetFacebook').sortable('destroy');
        }
        $('#widgetFacebook')
            .disableSelection()
            .sortable({
                connectWith: ['.editable_area', '.RVWYSIWYGAREA *'],
                cancel: '.consonant',
                appendTo: 'body',
                opacity: '.5',
                start: function (e, ui) {
                    //	$('.RVWYSIWYGAREA').disableSelection().sortable()
                },
                sort: function (e, ui) {
                    RVwys.hidemgActive();
                },
                placeholder: {
                    element: function (e, li) {
                        return $($('.tpl-placeholder').html())[0];
                    },
                    update: function (e, li) {
                        return;
                    },
                },
                helper: function (e, li) {
                    this.copyHelper = li.clone().insertAfter(li);
                    $(this).data('copied', false);
                    return $(
                        '<div class ="rvSWDhelper" style="width:200px;border:solid 3px #fcfcfc;"></div>'
                    );
                },

                stop: function (e, ui) {
                    var $uiItem = $(ui.item);
                    if ($uiItem.parent().is('#widgetFacebook'))
                        $uiItem.remove();
                    $('.layoutResize').remove();

                    $('.RVWYSIWYGAREA')
                        .find('*')
                        .each(function () {
                            if ($(this).hasClass('ui-sortable')) {
                                //$(this).enableSelection().sortable('destroy');
                            }
                            if ($(this).get(0).className == '') {
                                $(this).removeAttr('class');
                            }
                        });
                },
            });

        //element for edit facbook like
        parent
            .jQuery('body')
            .off('change', '.inputEditFacebooklike')
            .on('change', '.inputEditFacebooklike', function () {
                RVwys.widget.facebook.editFbLike();
            });
        //save edit facebook like
        parent
            .jQuery('body')
            .off('click', '#saveEditFacebookLikeUIkit')
            .on('click', '#saveEditFacebookLikeUIkit', function () {
                RVwys.widget.facebook.saveFblike($(this));
            });

        //element for edit facbook comment
        parent
            .jQuery('body')
            .off('change', '.inputEditFacebookComment')
            .on('change', '.inputEditFacebookComment', function () {
                RVwys.widget.facebook.editFbComments();
            });

        //save edit facebook like
        parent
            .jQuery('body')
            .off('click', '#saveEditFacebookCommentsUIkit')
            .on('click', '#saveEditFacebookCommentsUIkit', function () {
                RVwys.widget.facebook.saveFbComments($(this));
            });

        //element for edit facbook page
        parent
            .jQuery('body')
            .off('change', '.inputEditFacebookPage')
            .on('change', '.inputEditFacebookPage', function () {
                RVwys.widget.facebook.editFbPage();
            });
        //save edit facebook page
        parent
            .jQuery('body')
            .off('click', '#saveEditFacebookPageUIkit')
            .on('click', '#saveEditFacebookPageUIkit', function () {
                RVwys.widget.facebook.saveFbPage($(this));
            });
    });
})(jQuery);
